// extracted by mini-css-extract-plugin
module.exports = {"root":"txgPFJXLaswHwFtJ8IlZ","titleWrapper":"Cx6Ahs3ONSEV8hSg49XD","title":"Svtvq5q6nLxwNDTW0u1J","description":"e7FAX_OnAuZHnfY2cu7y"};